import React, { useState } from "react";
import "./Main.css";

const Main = () => {
  const [words, setWords] = useState(0);
  const [characters, setCharacters] = useState(0);

  const numberOfWords = () => {
    let data = document.querySelector("textarea").value;
    data = data.trim();
    if (data === "") {
      setWords(0);
    }
    const words = data.split(" ");
    const filteredWords = words.filter((word) => word !== "");
    setWords(filteredWords.length);
  };

  const numberOfCharacters = () => {
    let data = document.querySelector("textarea").value;
    const trimmedStr = data.replace(/\s/g, "");
    setCharacters(trimmedStr.length);
  };

  const toUppercase = () => {
    const uppercaseData = document
      .querySelector("textarea")
      .value.toUpperCase();
    document.querySelector("textarea").value = uppercaseData;
  };

  const toLowercase = () => {
    const lowercaseData = document
      .querySelector("textarea")
      .value.toLowerCase();
    document.querySelector("textarea").value = lowercaseData;
  };

  const toCapitalize = () => {
    const words = document
      .querySelector("textarea")
      .value.toLowerCase()
      .split(" ");

    const capitalizedSentence = words
      .map((word) => {
        const capitalizedFirstLetter = word.charAt(0).toUpperCase();
        const restOfWord = word.slice(1);
        return capitalizedFirstLetter + restOfWord;
      })
      .join(" ");
    document.querySelector("textarea").value = capitalizedSentence;
  };

  const toReverse = () => {
    const reversedStr = document
      .querySelector("textarea")
      .value.split("")
      .reverse()
      .join("");
    document.querySelector("textarea").value = reversedStr;
  };

  const toEncode = () => {
    const encodedString = btoa(document.querySelector("textarea").value);
    document.querySelector("textarea").value = encodedString;
  };

  const toDecode = () => {
    const decodedString = atob(document.querySelector("textarea").value);
    document.querySelector("textarea").value = decodedString;
  };

  const toCopy = () => {
    document.querySelector("textarea").select();
    document.execCommand("copy");
    alert("Text copied to clipboard!");
  };
  const toClear = () => {
    document.querySelector("textarea").value = "";
    numberOfWords();
    numberOfCharacters();
  };

  function downloadTextAsFile() {
    // Get the text from the textarea
    const text = document.getElementById("textarea").value;

    console.log(text);
    if (text.length <= 0) {
      return 0;
    }

    // Create a Blob object with the text
    const blob = new Blob([text], { type: "text/plain" });

    // Create a link element
    const link = document.createElement("a");

    // Set the download attribute with a filename
    link.download = "Texify-Elite.txt";

    // Create a URL for the Blob and set it as the href attribute
    link.href = window.URL.createObjectURL(blob);

    // Append the link to the document body
    document.body.appendChild(link);

    // Programmatically click the link to trigger the download
    link.click();

    // Remove the link from the document
    document.body.removeChild(link);
  }
  function removeWhitespace() {
    const inputText = document.getElementById("textarea").value;
    const transformedText = inputText.replace(/\s+/g, "");
    document.getElementById("textarea").value = transformedText;
    numberOfCharacters();
    numberOfWords();
  }
  function removeSpecialCharacters() {
    const inputText = document.getElementById("textarea").value;
    const transformedText = inputText.replace(/[^a-zA-Z0-9 ]/g, "");
    document.getElementById("textarea").value = transformedText;
    numberOfCharacters();
    numberOfWords();
  }

  function replaceCharacters() {
    const inputText = document.getElementById("textarea").value;
    const oldChar = prompt("Enter the character to be replaced:");
    const newChar = prompt("Enter the new character:");
    const transformedText = inputText.split(oldChar).join(newChar);
    document.getElementById("textarea").value = transformedText;
    numberOfCharacters();
    numberOfWords();
  }

  function generateText() {
    // Ask the user for the number of words using an alert
    const wordCount = parseInt(prompt("Enter the number of words:"), 10);

    // Check if the input is a valid number
    if (isNaN(wordCount) || wordCount <= 0) {
      alert("Please enter a valid number of words.");
      return;
    }

    // Generate the specified number of Lorem Ipsum words
    const words = generateLoremIpsumWords(wordCount);

    // Set the generated text to the textarea
    document.getElementById("textarea").value = words.join(" ");
    numberOfCharacters();
    numberOfWords();
  }

  function generateLoremIpsumWords(count) {
    const loremIpsumText =
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.";
    const loremIpsumWords = loremIpsumText.split(" ");

    let randomWords = [];
    for (let i = 0; i < count; i++) {
      const randomIndex = Math.floor(Math.random() * loremIpsumWords.length);
      randomWords.push(loremIpsumWords[randomIndex]);
    }
    return randomWords;
  }
  return (
    <div className="main-section">
      <div className="textarea-div">
        <textarea
          id="textarea"
          className="textarea"
          placeholder="Enter your text here..."
          onChange={() => {
            numberOfWords();
            numberOfCharacters();
          }}
        />
      </div>
      <div className="button-container">
        <div className="button-div">
          <button className="my-button btn-primary" onClick={toUppercase}>
            UpperCase
          </button>
          <button className="my-button btn-primary" onClick={toLowercase}>
            LowerCase
          </button>
          <button className="my-button btn-primary" onClick={toCapitalize}>
            Capitalize
          </button>
          <button className="my-button btn-primary" onClick={toReverse}>
            Reverse
          </button>
          <button className="my-button btn-primary" onClick={toEncode}>
            Encode
          </button>
          <button className="my-button btn-primary" onClick={toDecode}>
            Decode
          </button>

          <button className="my-button btn-secondary" onClick={downloadTextAsFile}>
            Download
          </button>
          <button className="my-button btn-secondary" onClick={replaceCharacters}>
            Replace
          </button>
          <button className="my-button btn-secondary" onClick={generateText}>
            Generate Text
          </button>
          

          <button className="my-button btn-secondary" onClick={removeWhitespace}>
            Remove WhiteSpace
          </button>
          <button className="my-button btn-secondary" onClick={removeSpecialCharacters}>
            Remove Special Characters
          </button>
          <button
            className="my-button btn-green"
            onClick={toCopy}
          >
            Copy
          </button>
          <button
            className="my-button btn-red"
            onClick={() => {
              toClear();
            }}
          >
            Clear
          </button>
        </div>
      </div>

      <section className="text-summary">
            <h2>Text Summary</h2>
            <div className="summary-item">
                <span>Number of Characters:</span>
                <span>{characters}</span>
            </div>
            <div className="summary-item">
                <span>Number of Words:</span>
                <span>{words}</span>
            </div>
        </section>
    </div>
  );
};

export default Main;
